export default __webpack_public_path__ + "static/media/Return-Policy.770c91d6.jpg";